import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

export const NoScoresForSsqMessage = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get("returnUrl");

    return (
        <Stack alignItems="center" padding={theme.spacing(2)}>
            <Stack maxWidth={"50%"}>
                <Typography variant="body-medium">
                    {t("scores.no_ssq_scores_defined", "No scores were setup for this questionnaire yet")}
                </Typography>
                {returnUrl && (
                    <Button variant="primary" href={returnUrl}>
                        {t("common.actions.back", "Back")}
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};
